import * as React from "react";
import {match, Redirect, Switch} from "react-router";
import ScheduleMap from "../components/schedule/ScheduleMap";
import RestrictedRoute from "./route/RestrictedRoute";
import AppointmentCalendar from "../components/appointment/calendar/AppointmentCalendar";
import {UserPermission} from "../model/user/UserPermission";
import AppointmentList from "../components/appointment/AppointmentList";
import DayView from "../components/dayView/DayView";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 * Schedule router.
 */
export default class ScheduleRouter extends React.PureComponent <RouteProps, {}> {

	render() {
		return (
			<Switch>
				<RestrictedRoute path={this.props.match.url + "/appointments/calendar"}
								 component={AppointmentCalendar}
								 allowedPermissions={[UserPermission.ScheduleAppointments]}/>
				<RestrictedRoute path={this.props.match.url + "/appointments"}
								 component={AppointmentList}
								 //TODO: apply proper permissions
								 allowedPermissions={[UserPermission.ScheduleAppointments]}/>
				<RestrictedRoute path={this.props.match.url + "/plan"}
								 component={DayView}
								 allowedPermissions={[UserPermission.ScheduleAppointments]}/>
				<RestrictedRoute path={this.props.match.url}
								 component={ScheduleMap}
								 allowedPermissions={[UserPermission.ScheduleMap]}/>
				<Redirect to={this.props.match.url}/>
			</Switch>
		)
	}

}